/* @license Copyright 2024 @polkadot-ui/library authors & contributors
SPDX-License-Identifier: MIT */
import { NetworkInformation } from "../types";
import acalaJson from "./Acala.json";
const acala: NetworkInformation = acalaJson;
import ajunaJson from "./Ajuna.json";
const ajuna: NetworkInformation = ajunaJson;
import aleph_zeroJson from "./Aleph_Zero.json";
const aleph_zero: NetworkInformation = aleph_zeroJson;
import aleph_zero_testnetJson from "./Aleph_Zero_Testnet.json";
const aleph_zero_testnet: NetworkInformation = aleph_zero_testnetJson;
import astarJson from "./Astar.json";
const astar: NetworkInformation = astarJson;
import bajunJson from "./Bajun.json";
const bajun: NetworkInformation = bajunJson;
import basiliskJson from "./Basilisk.json";
const basilisk: NetworkInformation = basiliskJson;
import bifrostJson from "./Bifrost.json";
const bifrost: NetworkInformation = bifrostJson;
import bifrost_kusamaJson from "./Bifrost_Kusama.json";
const bifrost_kusama: NetworkInformation = bifrost_kusamaJson;
import contractsJson from "./Contracts.json";
const contracts: NetworkInformation = contractsJson;
import hydradxJson from "./HydraDX.json";
const hydradx: NetworkInformation = hydradxJson;
import idiyanale_testnetJson from "./Idiyanale_Testnet.json";
const idiyanale_testnet: NetworkInformation = idiyanale_testnetJson;
import karuraJson from "./Karura.json";
const karura: NetworkInformation = karuraJson;
import khalaJson from "./Khala.json";
const khala: NetworkInformation = khalaJson;
import kusamaJson from "./Kusama.json";
const kusama: NetworkInformation = kusamaJson;
import kusama_asset_hubJson from "./Kusama_Asset_Hub.json";
const kusama_asset_hub: NetworkInformation = kusama_asset_hubJson;
import kusama_bridgehubJson from "./Kusama_BridgeHub.json";
const kusama_bridgehub: NetworkInformation = kusama_bridgehubJson;
import moonbase_alphaJson from "./Moonbase_Alpha.json";
const moonbase_alpha: NetworkInformation = moonbase_alphaJson;
import moonbase_relayJson from "./Moonbase_Relay.json";
const moonbase_relay: NetworkInformation = moonbase_relayJson;
import moonbeamJson from "./Moonbeam.json";
const moonbeam: NetworkInformation = moonbeamJson;
import moonriverJson from "./Moonriver.json";
const moonriver: NetworkInformation = moonriverJson;
import phalaJson from "./Phala.json";
const phala: NetworkInformation = phalaJson;
import polkadotJson from "./Polkadot.json";
const polkadot: NetworkInformation = polkadotJson;
import polkadot_asset_hubJson from "./Polkadot_Asset_Hub.json";
const polkadot_asset_hub: NetworkInformation = polkadot_asset_hubJson;
import polkadot_bridgehubJson from "./Polkadot_BridgeHub.json";
const polkadot_bridgehub: NetworkInformation = polkadot_bridgehubJson;
import polkadot_collectivesJson from "./Polkadot_Collectives.json";
const polkadot_collectives: NetworkInformation = polkadot_collectivesJson;
import rococoJson from "./Rococo.json";
const rococo: NetworkInformation = rococoJson;
import rococo_asset_hubJson from "./Rococo_Asset_Hub.json";
const rococo_asset_hub: NetworkInformation = rococo_asset_hubJson;
import rococo_bridgehubJson from "./Rococo_BridgeHub.json";
const rococo_bridgehub: NetworkInformation = rococo_bridgehubJson;
import shibuyaJson from "./Shibuya.json";
const shibuya: NetworkInformation = shibuyaJson;
import shidenJson from "./Shiden.json";
const shiden: NetworkInformation = shidenJson;
import tangleJson from "./Tangle.json";
const tangle: NetworkInformation = tangleJson;
import tinkernetJson from "./Tinkernet.json";
const tinkernet: NetworkInformation = tinkernetJson;
import tokyoJson from "./Tokyo.json";
const tokyo: NetworkInformation = tokyoJson;
import watrJson from "./Watr.json";
const watr: NetworkInformation = watrJson;
import westendJson from "./Westend.json";
const westend: NetworkInformation = westendJson;
import westend_asset_hubJson from "./Westend_Asset_Hub.json";
const westend_asset_hub: NetworkInformation = westend_asset_hubJson;
import westend_bridgehubJson from "./Westend_BridgeHub.json";
const westend_bridgehub: NetworkInformation = westend_bridgehubJson;
import westend_collectivesJson from "./Westend_Collectives.json";
const westend_collectives: NetworkInformation = westend_collectivesJson;
export {
  acala,
  ajuna,
  aleph_zero,
  aleph_zero_testnet,
  astar,
  bajun,
  basilisk,
  bifrost,
  bifrost_kusama,
  contracts,
  hydradx,
  idiyanale_testnet,
  karura,
  khala,
  kusama,
  kusama_asset_hub,
  kusama_bridgehub,
  moonbase_alpha,
  moonbase_relay,
  moonbeam,
  moonriver,
  phala,
  polkadot,
  polkadot_asset_hub,
  polkadot_bridgehub,
  polkadot_collectives,
  rococo,
  rococo_asset_hub,
  rococo_bridgehub,
  shibuya,
  shiden,
  tangle,
  tinkernet,
  tokyo,
  watr,
  westend,
  westend_asset_hub,
  westend_bridgehub,
  westend_collectives,
};
